import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Pagination,
  InputAdornment,
  // Chip,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGenerationkeys } from "../../store/keygenreration/action";
import AddIcon from "../../assets/svg/Addicon.svg";
import ListOfscreener from "./ListOfscreener";
import moment from "moment/moment";

const formattedDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const GenerationkeyList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { generationkeysList } = useSelector((state) => state.keygenreration);
  const [screenerStudioOrClickOps, setScreenerStudioOrClickOps] =
    useState("screenerStudio");
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    dispatch(getGenerationkeys());
  }, []);

  // Filtered data based on search
  const filteredData =
    generationkeysList?.data?.filter(
      (row) =>
        row?.EnterpriseName?.toLowerCase().includes(searchText.toLowerCase()) ||
        row?.LicenseName?.toLowerCase().includes(searchText.toLowerCase())
    ) || [];

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
  return (
    <>
      <Box
        sx={{
          margin: "25px",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            Generation keys
          </Typography>
          <Typography variant="body2" color="textSecondary">
            List of all the keys
          </Typography>
        </Box>
        <Box>
          <FormControlLabel
            control={
              <Switch
                checked={screenerStudioOrClickOps === "screenerStudio"}
                onChange={(e) =>
                  setScreenerStudioOrClickOps(
                    e.target.checked ? "screenerStudio" : "clickOps"
                  )
                }
                inputProps={{
                  "aria-label": "Switch between Screener Studio and ClickOps",
                }}
              />
            }
            label={"Screener Studio"}
          />
          <Button
            sx={{ height: "40px" }}
            variant="contained"
            size="small"
            endIcon={<img src={AddIcon} alt="Add" />}
            onClick={() => navigate("/add-generatekey")}
          >
            Add
          </Button>
        </Box>
      </Box>
      {screenerStudioOrClickOps !== "screenerStudio" ? (
        <Box
          sx={{
            padding: "20px",
            backgroundColor: "#fff",
            margin: "25px",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <TextField
              placeholder="Search by enterprise or license"
              variant="outlined"
              size="small"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setCurrentPage(1);
              }}
              sx={{ width: 350 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Enterprise Name</TableCell>
                  <TableCell>License Name</TableCell>
                  <TableCell>Admin</TableCell>
                  <TableCell>End Users</TableCell>
                  <TableCell>Process Owner</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Valid From</TableCell>
                  <TableCell>Valid To</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((row) => (
                  <TableRow
                    key={row.LicenseTypeID}
                    hover
                    onClick={() =>
                      navigate(`/key`, { state: { payload: row } })
                    }
                    sx={{ cursor: "pointer" }}
                  >
                    <TableCell>{row?.EnterpriseName}</TableCell>
                    <TableCell>{row?.LicenseName}</TableCell>
                    <TableCell>{row?.NumberOfAdminUsers}</TableCell>
                    <TableCell
                      sx={row?.PerpetualEndUser ? { fontSize: 25 } : {}}
                    >
                      {row?.PerpetualEndUser ? "∞" : row?.NumberOfEndUsers}
                    </TableCell>
                    <TableCell
                      sx={row?.PerpetualProcessOwner ? { fontSize: 25 } : {}}
                    >
                      {row?.PerpetualProcessOwner
                        ? "∞"
                        : row?.NumberOfProcessOwnerUsers}
                    </TableCell>
                    <TableCell>{moment(row?.CreatedDate).format("DD-MM-YYYY, hh:mm A")}</TableCell>
                    <TableCell>{formattedDate(row?.ValidityFrom)}</TableCell>
                    <TableCell>{formattedDate(row?.ValidityTo)}</TableCell>
                  </TableRow>
                ))}
                {paginatedData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No matching records found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
              siblingCount={0}
              boundaryCount={1}
            />
          </Box>
        </Box>
      ) : (
        <ListOfscreener />
      )}
    </>
  );
};

export default GenerationkeyList;
